import { render, staticRenderFns } from "./ed-content-sidebar-section.component.vue?vue&type=template&id=11ea7398&scoped=true&"
import script from "./ed-content-sidebar-section.component.ts?vue&type=script&lang=ts&"
export * from "./ed-content-sidebar-section.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-sidebar-section.component.scss?vue&type=style&index=0&id=11ea7398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ea7398",
  null
  
)

export default component.exports